import { FormMultiSelector, FormSelect, Typography, FormInput, Label, Form } from '@ui/components';
import { FormLabelsPicker } from '@shared/components';
import { PhoneCodes, Masks } from '@helpers/constant';
import { UseFormReturn } from 'react-hook-form';
import { LabelType } from '@interfaces/models';
import { useTranslation } from 'react-i18next';
import { useGetVehicles } from '@shared/hooks';

import { EditEmployeesForm } from './use-edit-employee-drawer-form';

export const EditEmployeesDrawerForm = ({ form }: { form: UseFormReturn<EditEmployeesForm> }) => {
  const { t } = useTranslation();
  const { vehiclesOptions } = useGetVehicles();

  return (
    <Form {...form}>
      <form className="grid grid-cols-6 gap-2 items-center">
        <Label className="col-span-2" htmlFor="firstName">
          <Typography variant="labelSmallBook">
            {t('ONBOARDING.IMPORT_EMPLOYEES.EDIT_EMPLOYEE_DRAWER_FIRST_NAME')}
          </Typography>
        </Label>
        <FormInput
          placeholder={t('ONBOARDING.IMPORT_EMPLOYEES.EDIT_EMPLOYEE_DRAWER_FIRST_NAME')}
          className="w-full col-span-4"
          formControl={form.control}
          name="firstName"
          size="small"
        />

        <Label className="col-span-2" htmlFor="lastName">
          <Typography variant="labelSmallBook">
            {t('ONBOARDING.IMPORT_EMPLOYEES.EDIT_EMPLOYEE_DRAWER_LAST_NAME')}
          </Typography>
        </Label>
        <FormInput
          placeholder={t('ONBOARDING.IMPORT_EMPLOYEES.EDIT_EMPLOYEE_DRAWER_LAST_NAME')}
          className="w-full col-span-4"
          formControl={form.control}
          name="lastName"
          size="small"
        />

        <Label className="col-span-2" htmlFor="phoneNumber">
          <Typography variant="labelSmallBook">
            {t('ONBOARDING.IMPORT_EMPLOYEES.EDIT_EMPLOYEE_DRAWER_PHONE_NUMBER')}
          </Typography>
        </Label>
        <div className="grid grid-cols-4 gap-4 items-center col-span-4">
          <FormSelect
            placeholder={t('ONBOARDING.IMPORT_EMPLOYEES.EDIT_EMPLOYEE_DRAWER_PHONE_CODE')}
            className="w-full col-span-1"
            formControl={form.control}
            options={PhoneCodes}
            name="phoneExt"
          />
          <FormInput
            componentProps={{
              maskOptions: { mask: Masks.PHONE },
            }}
            placeholder={t('ONBOARDING.IMPORT_EMPLOYEES.EDIT_EMPLOYEE_DRAWER_PHONE_NUMBER')}
            className="w-full col-span-3"
            formControl={form.control}
            name="phoneNumber"
            size="small"
          />
        </div>

        <Label className="col-span-2" htmlFor="email">
          <Typography variant="labelSmallBook">
            {t('ONBOARDING.IMPORT_EMPLOYEES.EDIT_EMPLOYEE_DRAWER_EMAIL')}
          </Typography>
        </Label>
        <FormInput
          placeholder={t('ONBOARDING.IMPORT_EMPLOYEES.EDIT_EMPLOYEE_DRAWER_EMAIL')}
          className="w-full col-span-4"
          formControl={form.control}
          name="email"
          size="small"
        />

        <Label htmlFor="assignedVehicles" className="col-span-2">
          <Typography variant="labelSmallBook">
            {t('ONBOARDING.IMPORT_EMPLOYEES.EDIT_EMPLOYEE_DRAWER_ASSIGNED_VEHICLES')}
          </Typography>
        </Label>
        {/* TODO: Replace with autocomplete */}
        <FormMultiSelector
          componentProps={{
            id: 'assignedVehicles',
            contentSearch: {
              placeholder: t('ONBOARDING.IMPORT_EMPLOYEES.EDIT_EMPLOYEE_DRAWER_ASSIGNED_VEHICLES'),
            },
          }}
          placeholder={t('ONBOARDING.IMPORT_EMPLOYEES.EDIT_EMPLOYEE_DRAWER_ASSIGNED_VEHICLES')}
          className="w-full col-span-4"
          formControl={form.control}
          options={vehiclesOptions}
          name="assignedVehicles"
        />

        <Label className="col-span-2" htmlFor="labels">
          <Typography variant="labelSmallBook">
            {t('ONBOARDING.IMPORT_EMPLOYEES.EDIT_EMPLOYEE_DRAWER_LABEL')}
          </Typography>
        </Label>
        <FormLabelsPicker
          placeholder={t('ONBOARDING.IMPORT_EMPLOYEES.EDIT_EMPLOYEE_DRAWER_LABEL')}
          componentProps={{ hasShadow: true, id: 'labels' }}
          labelType={LabelType.EMPLOYEE}
          className="w-full col-span-4"
          formControl={form.control}
          name="labels"
          size="small"
        />
      </form>
    </Form>
  );
};
